import Axios from 'axios'
import AxiosDefaultRequestConfig from './AxiosDefaultRequestConfig'
import AxiosPostProcessor from './AxiosPostProcessor'

export interface IosAccountLinkTokenResponse {
    token: string
    url: string
    expiresUtc: string
}

export class IosAccountLinkServiceStatic {
    createLinkToken() {
        const url = `${process.env.VUE_APP_BASE_URL_API}/api/account-link-token`
        return AxiosPostProcessor.postProcess(
            Axios.post<IosAccountLinkTokenResponse>(url, {}, AxiosDefaultRequestConfig.merge({}))
        )
    }
}

const IosAccountLinkService = new IosAccountLinkServiceStatic()

export default IosAccountLinkService
